/* eslint-disable @typescript-eslint/no-unused-vars */
const DEV = "DEV";
const PROD = "PROD";

export const ENV = PROD;
